import { routes } from "src/shared/routes";
import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  TERMS_AND_CONDITION,
} from "./helper";

import orderSummaryBg from "public/images/azdbacks/arizona-diamondbacks-baseball-field.jpg";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const pass_ekata: TTeamConfig = {
  TEAM_SCHEMA: "pass_ekata",
  TEAM_FULL_NAME: "Attend Events Ekata Sandbox",
  BROWSER_TITLE: "Attend Events Ekata Sandbox",
  CLIENT_ID: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#A71930",
    COLORS_SECONDARY: "#E3D4AD",
    IS_INTERCOM_ENABLED: true,
    IS_BALLPARK_APP: true,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },
    DEFAULT_APP_ROUTE: routes.landing,
    FOOTER: {
      BACKGROUND_COLOR: "#A71930",
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()}`,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/AZD-UPDATED.png",
    ORDER_SUMMERY_BACKGROUND_URL: orderSummaryBg.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
